import styled from "styled-components";
import device from "utils/device";

export const Footer = styled.div`
  display: none;

  @media ${device.tablet} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 12px;
    color: #334D6E;
  }
`;